import Constants from "constants/index";
import MedkitService from "./medkit.service";
import { IUserProfileDetail } from "commons/interfaces";

class UserProfileService extends MedkitService {

    public detail = async (userId: string): Promise<IUserProfileDetail> => {
        const result = await this.api.get({
            path: `${Constants.ApiPath.USER_PROFILE.DETAIL}/${userId}`,
        });
        return result.data.result;
    };

    public update = async (data: {
        id?: string,
        userId?: string,
        organizationId?: string,
        extraInformation?: string,
    }) => {
        const result = await this.api.put({
            path: Constants.ApiPath.USER_PROFILE.UPDATE,
            data: data,
        });
        return result.data.result;
    };

    public invite = async (data: {
        email: string
        gender?: number
        fullname?: string
        birthDate?: number
        phoneNumber?: string
        note?: string
        roles?: string[]
        projectId: string
        groupIds?: string[]
        organizationId?: string
        extraInformation?: string
    }) => {
        const result = await this.api.post({
            path: Constants.ApiPath.USER_PROFILE.INVITE,
            data: data,
        });
        return result.data.result;
    };

}

export default UserProfileService;
